import { State } from './state'

const STATE_KEY = 'DASHBOARD__TATE_STATE'

export const storage = {
  clearState: (): void => localStorage.removeItem(STATE_KEY),
  retrieveState: (): State => JSON.parse(localStorage.getItem(STATE_KEY) || '{}'),
  saveState: (state: State) => localStorage.setItem(STATE_KEY, JSON.stringify(state))
}
